import React, { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import {
  Grid,
  CardHeader,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  IconButton,
  Stack,
  Link,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogProps,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { societyBillSeriesService } from "../../services/SocietyBillSeriesService";
import { societyBillsService } from "../../services/SocietyBillsService";
import { SocietyBillsModel } from "../../models/SocietyBillsModel";
import fileDownload from "js-file-download";
import { SelectListModel } from "../../models/ApiResponse";
import useForm from "../../utility/hooks/UseForm";
import Controls from "../../utility/controls/Controls";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import SmsIcon from "@mui/icons-material/Sms";
import { appInfoService } from "../../services/AppInfoService";
import { globalService } from "../../services/GlobalService";
import { societiesService } from "../../services/SocietiesService";
import { SocietiesModel } from "../../models/SocietiesModel";
import ConfirmDialog from "../helper/ConfirmDialog";
import { Messages, ROLES } from "../../utility/Config";
import { AuthContext } from "../../utility/context/AuthContext";
import { useSharedNavigation } from "../../utility/context/NavigationContext";
import BillView from "./BillView";

const SocietyBillForm = (...props: any) => {
  const { auth } = React.useContext(AuthContext);
  const { societyId }: any = useParams();
  let navigate = useNavigate();
  const [societyBills, setSocietyBills] = useState([]);
  const [billAbbreviations, setBillAbbreviations] = useState<SelectListModel[]>(
    []
  );
  const [isBillPopupOpen, setIsBillPopupOpen] = useState(false);

  const [billDates, setBillDates] = useState<SelectListModel[]>([]);
  let societySubscriptionId = localStorage.getItem("societySubscriptionId");

  const [societyBill, setSocietyBill] = useState<any>(null);
  const [society, setSociety] = useState<SocietiesModel>(null);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', onConfirm: () => { } });
  const { goToHome } = useSharedNavigation();
  const handleOpen = () => {
    setIsBillPopupOpen(true);
  };

  const handleClose = () => {
    setIsBillPopupOpen(false);
  };

  const validate = (fieldValues: SocietyBillsModel = values) => {
    let temp: any = { ...errors };

    if ("BillAbbreviation" in fieldValues)
      temp.BillAbbreviation = fieldValues.BillAbbreviation
        ? ""
        : "Bill Abbreviation is required.";
    // if ("BillDate" in fieldValues)
    //   temp.BillDate = fieldValues.BillDate ? "" : "Bill Date is required.";

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    societyBillsService.initialFieldAddSocietyBillValues,
    validate,
    societyId
  );

  const newSocietyBillSeries = () => {
    setValues(societyBillsService.initialFieldAddSocietyBillValues);
  };

  useEffect(() => {
    if (!globalService.isSocietySelected()) {
      globalService.info(Messages.SocietyUnSelected);
      return goToHome();
    }
    if (!society) getSociety();
    if (billAbbreviations.length === 0) getBillAbbreviation();
    else {
      //setIsReceiptVisible(true);
      //setIsReversalVisible(true);
      newSocietyBillSeries();
      //(SocietyCollectionReversals != true ? isReversalVisible : "")
      setErrors({});
    }
  }, [societyId]);

  const getSociety = () => {
    societiesService.getById(societyId).then((response) => {
      let result = response.data;
      setSociety(result.data);
    });
  };

  const getBillAbbreviation = () => {
    societyBillSeriesService
      .getSelectListBySocietyId(societyId)
      .then((response) => {
        setBillAbbreviations(response.data);
        // if (response.data.length > 0) {
        //   values.BillAbbreviation = response.data[0].Value;
        // }
      });
  };

  // const downloadPDF = (societyBillId: any) => {
  //   societyBillsService.createPdf(societyBillId).then((response) => {
  //     let result = response.data;
  //     fileDownload(result, "SocietyBill.pdf");
  //   });
  // }
  const downloadBillsReceiptsPDF = (billId: any) => {
    values.SocietyId = societyId;
    values.SocietySubscriptionId = societySubscriptionId;
    values.SocietyBillId = billId;
    let isValidated = billId ? true : validate(); // if single bill then no validate method will be called
    if (isValidated) {
      societyBillsService.createBillsReceiptsPdf(values).then((response) => {
        let result = response.data;
        fileDownload(result, "SocietyBillsReceipts.pdf");
      });
    }
  };

  const ListBillDates = (billAbbreviation: any) => {
    var societysubscriptionId = localStorage.getItem("societySubscriptionId");
    if (!societySubscriptionId) {
      return globalService.error('Please select society subscription.');
    }
    if (billAbbreviation) {
      societyBillsService
        .ListBillDatesBySubscriptionIDAndBillAbbr(
          societysubscriptionId,
          billAbbreviation
        )
        .then((response) => {
          setBillDates(response.data);
          // if (response.data.length > 0) {
          //   values.BillAbbreviation = response.data[0].Value;
          // }
        });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    values.SocietyId = societyId;
    if (validate()) {
      societyBillsService
        .GetBySocietyIDBillDateBillAbbreviation(values)
        .then((response) => {
          let result = response.data;
          setSocietyBills(result.list);
        });
    }
  };

  const SendEmail = (billId: any) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    })
    values.SocietyId = societyId;
    values.SocietySubscriptionId = societySubscriptionId;
    values.SocietyBillId = billId;
    let isValidated = billId ? true : validate(); // if single bill then no validate method will be called
    if (isValidated) {
      societyBillsService
        .SendBillEmail(values)
        .then((response) => {
          let result = response.data;
          if (result.isSuccess) {
            globalService.success(result.message);
          }
        });
    }
  }

  const SendSms = (billId: any) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    })
    values.SocietyId = societyId;
    values.SocietySubscriptionId = societySubscriptionId;
    values.SocietyBillId = billId;
    let isValidated = billId ? true : validate(); // if single bill then no validate method will be called
    if (isValidated) {
      societyBillsService
        .SendBillSms(values)
        .then((response) => {
          let result = response.data;
          if (result.isSuccess) {
            globalService.success(result.message);
          }
        });
    }
  }

  const columns: GridColDef[] = [
    {
      field: "Building",
      headerName: "Building",
      width: 130,
      flex: 1,
      valueGetter: (params) =>
        params.row.SocietyBuildingUnit?.SocietyBuilding?.Building,
    },
    // {
    //   field: "Member",
    //   headerName: "Member",
    //   width: 130,
    //   flex: 1,
    //   valueGetter: (params) =>
    //     params.row.SocietyMember?.Member,
    // },
    {
      field: "Rev",
      headerName: "Rev",
      width: 130,
      flex: 1,
      valueGetter: (params) =>
        params.row.SocietyCollectionReversals?.SocietyBuilding?.Building,
    },
    {
      field: "Unit",
      headerName: "Unit",
      width: 130,
      flex: 1,
      valueGetter: (params) => params.row.SocietyBuildingUnit?.Unit,
    },
    { field: "BillNo", headerName: "Bill No", width: 130, flex: 2 },
    {
      field: "UAmount", headerName: "Amount", width: 130, flex: 1,
      headerClassName: 'header-right', cellClassName: 'cell-right',
      renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
    },
    {
      field: "Arrears", headerName: "Arrears", width: 130, flex: 1,
      headerClassName: 'header-right', cellClassName: 'cell-right',
      renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
    },
    {
      field: "InterestArrears",
      headerName: "Interest Arrears",
      width: 90,
      headerClassName: 'header-right', cellClassName: 'cell-right',
      renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }

    },
    {
      field: "Interest", headerName: "Interest", width: 130, flex: 1,
      headerClassName: 'header-right', cellClassName: 'cell-right',
      renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
    },
    {
      field: "Payable", headerName: "Payable", width: 130, flex: 1,
      headerClassName: 'header-right', cellClassName: 'cell-right',
      renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
    },
    {
      field: "Actions",
      headerName: "Actions",
      type: "number",
      flex: 2.5,
      renderCell: (params) => {
        return (
          <Stack direction="row" spacing={0}>
            <Button className="btnGrid" size="small" variant="contained"
              onClick={() => {
                setSocietyBill(params.row)
                handleOpen()
              }}>View</Button>
            {society && society.EnableEmail === true && <Button
              className="btnGrid"
              variant="contained"
              size="small"
              onClick={() => SendEmail(params.row.SocietyBillId)}
            >
              Send Email
            </Button>
            }
            {society && society.EnableSms === true &&
              <Button
                className="btnGrid"
                variant="contained"
                size="small"
                onClick={() => SendSms(params.row.SocietyBillId)}
              >
                Send SMS
              </Button>
            }
          </Stack>
        );
      },
    },
  ];

  return (
    <>
      <Typography variant="h5" align="center">
        Society Bills
      </Typography>
      <form noValidate onSubmit={handleSubmit}>
        <Card>
          <CardHeader title="Billing Parameters" />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <Controls.Select
                  name="BillAbbreviation"
                  label="Bill Abbreviation"
                  required
                  showEmptyItem={true}
                  options={billAbbreviations}
                  value={
                    billAbbreviations.length > 0 ? values.BillAbbreviation : ""
                  }
                  onChange={(e: any) => {
                    handleInputChange(e);
                    ListBillDates(e.target.value);
                  }}
                  error={errors.BillAbbreviation}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Select
                  name="BillDate"
                  showEmptyItem={false}
                  label="Bill Date"
                  required
                  value={billDates.length > 0 ? values.BillDate : ""}
                  onChange={handleInputChange}
                  options={billDates}
                  error={errors.BillDate}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button type="submit" variant="contained" className={!globalService.roleMatch([ROLES.ReadOnly], auth) ? '' : 'hidden'}>
                  Go
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Button
              style={{ marginRight: "2vh" }}
              variant="contained"
              startIcon={<DownloadIcon />}
              // size="small"
              onClick={() => downloadBillsReceiptsPDF(null)}
            >
              Download Bills/Receipts PDF
            </Button>
            {society && society.EnableEmail === true && <Button
              //disabled
              style={{ marginRight: "2vh" }}
              variant="contained"
              startIcon={<EmailIcon />}
              //onClick={() => SendEmail(null)}
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "Are you sure you want to Send Email to all? ",
                  onConfirm: () => { SendEmail(null) }
                })
              }}
            >
              Send Email to All
            </Button>
            }
            {society && society.EnableSms === true &&
              <Button
                style={{ marginRight: "2vh" }}
                variant="contained"
                startIcon={<SmsIcon />}
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Are you sure you want to Send SMS to all? ",
                    onConfirm: () => { SendSms(null) }
                  })
                }}
              >
                Send SMS to All
              </Button>
            }

            <div style={{ width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.SocietyBillId}
                rows={societyBills}
                columns={columns}
                columnHeaderHeight={30}
                //rowHeight={30}
                autoHeight={true}
                getRowHeight={() => "auto"}
                getEstimatedRowHeight={() => 200}
                initialState={{
                  columns: {
                    columnVisibilityModel: {},
                  },
                  pagination: { paginationModel: { pageSize: 10 } },
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
              />
            </div>
          </CardContent>
        </Card>
        <Stack spacing={2} direction="row" justifyContent={"center"}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Stack>
      </form>

      <div>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </div>
      {societyBill && <BillView
        open={isBillPopupOpen}
        onClose={handleClose}
        SocietyBillId={societyBill.SocietyBillId}
        BillAbbreviation={societyBill.BillAbbreviation}
        SocietyId={societyBill.SocietyId}
        SocietySubscriptionId={societyBill.SocietySubscriptionId}
      />
      }
    </>
  );
};

export default SocietyBillForm;
